import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles, Advice, Text } from '@Sage/hoi-poi-ui';

import { useWeb5Context } from 'lib/Web5Context';
import styles from './styles/advice.styles';
const useStyles = createUseStyles(styles, 'AdviceRelatedFields');

const AdviceRelatedFields = ({ fields }) => {
    const classes = useStyles();
    const { t } = useWeb5Context();
    const keys = Object.keys(fields);
    return (
        <Advice
            className={classes.root}
            title={
                <Text className={classes.adviceTitle} bold>
                    {t('cfm_label_related_entities')}
                </Text>
            }
            showIcon
            type="info"
        >
            {keys.map((key, index) => (
                <div key={key} className={classes.entity}>
                    {index > 0 && <div className={classes.divider}></div>}
                    <Text className={classes.entityTitle} bold>
                        {key}
                    </Text>
                    {fields[key].map((field) => (
                        <Text key={field} className={classes.field}>
                            {t(field)}
                        </Text>
                    ))}
                </div>
            ))}
        </Advice>
    );
};

AdviceRelatedFields.propTypes = {
    fields: PropTypes.object,
};

export default memo(AdviceRelatedFields);
